import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqItems } from '../data/mock';
import { HelpCircle } from 'lucide-react';

const FAQSection = () => {
  return (
    <section id="faq" className="relative py-10 md:py-14 bg-black overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#004048]/15" />
      
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-[1fr_2fr] gap-8 lg:gap-12">
          <div>
            <div className="lg:sticky lg:top-24">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#004048]/40 border border-[#59d862]/20 rounded-full mb-3">
                <HelpCircle className="w-4 h-4 text-[#59d862]" />
                <span className="text-[#59d862] text-sm font-medium">FAQ</span>
              </div>
              <h2 className="text-2xl md:text-4xl font-bold mb-3 heading">Common <span className="text-[#59d862]">Questions</span></h2>
              <p className="text-white/55 text-sm leading-relaxed mb-4">Everything you need to know about Gazeal Advance.</p>
              <div className="p-4 bg-[#59d862]/10 border border-[#59d862]/20 rounded-xl">
                <p className="text-white/70 text-xs mb-1">Still have questions?</p>
                <a href="mailto:advance@gazeal.co.uk" className="text-[#59d862] font-semibold text-sm hover:underline">Contact our team →</a>
              </div>
            </div>
          </div>

          <div>
            <Accordion type="single" collapsible className="space-y-2">
              {faqItems.map((item, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border border-white/[0.06] bg-white/[0.01] px-4 rounded-xl data-[state=open]:border-[#59d862]/20 data-[state=open]:bg-[#004048]/15 transition-all overflow-hidden">
                  <AccordionTrigger className="text-left text-white hover:text-[#59d862] hover:no-underline py-3 text-sm font-medium">{item.question}</AccordionTrigger>
                  <AccordionContent className="text-white/60 pb-3 leading-relaxed text-sm">{item.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
